export const EXPONEA_EVENT_TYPES = Object.freeze({
    CAR_VIEW: 'b2c_carView',
    FILTER_APPLIED: 'b2c_listApplyFilter',
    INTERESTED_CLICKED: 'b2c_clickCarInterested',
    INTERESTED_SUBMIT: 'b2c_carSubmitLead',
    SWAP_WIDGET_SELECT: 'b2c_carSelectTradein',
    SWAP_SUBMIT: 'b2c_carSubmitTradein',
    CF_SUBMIT: 'b2c_carSubmitFinance',
    CAR_REPORT_VIEW: 'b2c_carViewReport',
    CF_CONTACT_DATA: 'fin_contactData'
});

export const EXPONEA_EVENT_TO_KEY_MAP = Object.freeze({
    [EXPONEA_EVENT_TYPES.INTERESTED_SUBMIT]: '_csl_ids',
    [EXPONEA_EVENT_TYPES.SWAP_SUBMIT]: '_cst_ids',
    [EXPONEA_EVENT_TYPES.CF_SUBMIT]: '_cfs_ids'
});

export const EXPONEA_USER_FLOW = Object.freeze({
    B2C: 'B2C',
    C2B: 'C2B',
    FINANCE: 'FINANCE'
});

export const ITEM_PARAMETERS = ['make', 'model', 'variant', 'year'];
